<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <h3 class="card-title"><i class="ti-check-box"></i> {{ $t('Actions') }}</h3>
          </div>
          <div class="ml-auto">
            <button type="button" class="btn btn-sm btn-rounded btn-info" @click="showModal = !showModal"><i class="ti-plus"></i> {{ $t('Add action') }}</button>
          </div>
        </div>
        <div class="table-responsive m-t-20">  <!--style="overflow-y: scroll; height: 240px;">-->
          <table class="table vm no-th-brd pro-of-month">
            <tbody>
            <tr v-for="action in actionData">
              <td>
                <h2>
                  <i v-if="action.status === 'accept'" class="ti-more-alt text-info"></i>
                  <i v-else-if="action.status === 'done'" class="ti-check text-success"></i>
                  <i v-else-if="action.status === 'declined'" class="ti-close text-danger"></i>
                  <i v-else class="ti-settings text-info"></i>
                </h2>
              </td>
              <td>
                <h5 class="font-bold" v-html="action.title"></h5>
                <small class="text-muted">{{ $t(action.status) | ucFirst }} - </small>
                <small class="text-muted"> {{ action.Owner.firstname }} {{ action.Owner.lastname }}</small>
              </td>
              <td>
                <router-link class="overrule" :to="'/action/' + action.uid">
                  {{ $t("Details") }}
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <add-action-modal v-if="showModal" @close="showModal = false" :meeting="meetingId" v-on:actionAdded="addAction"></add-action-modal>

  </div>
</template>

<script>
  import AddActionModal from './AddActionModal';

  export default {
    props: {
      'action_data' : {
        default: []
      }
    },
    components: {
    "add-action-modal": AddActionModal
    },
    name: "actions-meeting-widget",
    data: function () {
      return {
        actionData: this.action_data,
        showModal: false,
        meetingId: ""
      }
    },
    methods: {
      addAction: function (event) {
        let actionToAdd = event;
        actionToAdd.status = "pending";
        this.actionData.unshift(actionToAdd);
      }
    },
    created(){
      this.meetingId = typeof this.$parent.meetingID === 'undefined' ? null : this.$parent.meetingID;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ActionsMeetingWidget.vue